export default __webpack_public_path__ + "static/media/template9.70ba9748.svg";